import { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import ToggleSection from "../../../components/UI/ToggleSection";
import { useSettings } from "../../../context/SettingsContext";

export default function LeadSources({ data }) {
  const [sources, setSources] = useState([]);
  const { updateLeadFeatures } = useSettings();

  const hydrated = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    if (!data || hydrated.current) return;
    setSources(data.sources || []);
    hydrated.current = true;
  }, [data]);

  useEffect(() => {
    if (!dirty.current) return;
    updateLeadFeatures({
      features: data.features,
      sources,
    });
  }, [sources]);

  return (
    <Box sx={{ maxWidth: 250 }}>
      <ToggleSection
        title="Lead Sources"
        items={sources}
        values={Object.fromEntries(sources.map((s) => [s.key, s.enabled]))}
        onToggle={(k) => {
          dirty.current = true;
          setSources((p) =>
            p.map((s) => (s.key === k ? { ...s, enabled: !s.enabled } : s)),
          );
        }}
      />
    </Box>
  );
}
